export default [
  {
    path: '/public/customer/settlements/:customerUid/pay',
    name: 'customer-settlements-pay',
    component: () => import('@/views/customer/settlements/payment/Payment'),
    meta: {
      title: 'navigation.payment',
      layout: 'full',
      isPublic: true,
    },
  },
  {
    path: '/public/customer/settlements/payment/:paymentId/status',
    name: 'customer-settlements-payment-status',
    component: () => import('@/views/customer/settlements/payment/PaymentStatus'),
    meta: {
      title: 'navigation.payment-status',
      layout: 'full',
      isPublic: true,
    },
  },
]
